'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Card, _Component);

    function Card(props) {
        (0, _classCallCheck3.default)(this, Card);
        return (0, _possibleConstructorReturn3.default)(this, (Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call(this, props));
    }

    (0, _createClass3.default)(Card, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                style = _props.style,
                title = _props.title,
                action = _props.action,
                contentHeight = _props.contentHeight,
                text = _props.text,
                subText = _props.subText,
                footer = _props.footer;

            return _react2.default.createElement(
                'div',
                { className: "cn-card " + className, style: style },
                _react2.default.createElement(
                    'div',
                    { className: 'cn-card-body' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cn-card-top' },
                        action ? _react2.default.createElement(
                            'div',
                            { className: 'cn-card-action' },
                            action
                        ) : null,
                        title ? _react2.default.createElement(
                            'div',
                            { className: 'cn-card-title' },
                            title
                        ) : null,
                        text ? _react2.default.createElement(
                            'div',
                            { className: 'cn-card-text' },
                            text
                        ) : null,
                        subText ? _react2.default.createElement(
                            'div',
                            { className: 'cn-card-subtext' },
                            subText
                        ) : null
                    ),
                    this.props.children ? _react2.default.createElement(
                        'div',
                        { className: 'cn-card-content', style: { height: contentHeight } },
                        this.props.children
                    ) : null,
                    footer ? _react2.default.createElement(
                        'div',
                        { className: 'cn-card-footer' },
                        footer
                    ) : null
                )
            );
        }
    }]);
    return Card;
}(_react.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    action: _propTypes2.default.element,
    contentHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    text: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    subText: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
    footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string])
}, _class.defaultProps = {
    contentHeight: 'auto'
}, _temp);
exports.default = Card;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Card.js
// module id = 596
// module chunks = 0